module.exports = __webpack_public_path__ + "img/spinner-solid.11e425a3.svg";